// @ts-strict-ignore
import fetch from "@lib/fetch";
import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { TeamsPayload } from "./types";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

export const getTeamsData = reactQueryTableFetcherAdapter(
  cacheKey,
  async (
    signal: AbortSignal,
    { appGroupId, query, sortby, sortdir, limit = 10, start = 0 }
  ): Promise<TeamsPayload> => {
    const teams = await fetch(
      cacheKey,
      "GET",
      {
        query: serializeQueryObjects(query),
        app_group_id: appGroupId,
        sortby,
        sortdir,
        limit,
        start,
      },
      { signal }
    );
    return teams;
  }
);
